<template>
<div class="modal micromodal-slide change_data" v-bind:class="{ 'is-open': this.open }">
  <div class="modal__overlay" v-on:click="close()"></div>
  <div class="modal_item">
    <div class="detail_wrap">
      <button v-on:click="close()" class="close"><span class="close_image"><img src="../../assets/images/close.png" alt=""></span></button>
      <h2 class="content_title">登録住所</h2>
      <div class="scroll mt24" ref="modal__content">
        <div v-for="(index, n) in deliveryAddressList" :key="n" class="payment_item right_arrow bdb pl16 pr20 pb10" v-bind:class="{ 'pt11': n != 0 }">
          <input v-bind:checked="deliveryAddressId == index.deliveryAddressId" v-bind:id="'address' + n" class="payment_radio" type="radio" name="address">
          <label v-bind:for="'address' + n" class="payment_contents rb" v-on:click="changeAddress(index.deliveryAddressId)">
            {{ index.recipientName }}
            <span class="zip rs">〒{{ index.address.zipCode }}</span>
            <span class="address rs">{{ index.address.prefecture.prefectureName }} {{ index.address.address }}</span>
          </label>
        </div>
      </div>
    </div>

    <div class="btn_wrap">
      <button v-on:click="send()" class="btn_yellow">この住所に届ける</button>
      <a href="#" class="btn_blue" @click.stop.prevent="addAddress()">住所を追加する</a>
    </div>
  </div>
</div>

</template>

<script>
import DeliveryAddress from '@/components/api/deliveryAddress'
import scrollPosition from '@/model/scrollPosition';
import { mapGetters } from 'vuex';

export default {
  data() {
    return {
      open: false,
      deliveryAddressId: 0,
      deliveryAddressList: [],
    }
  },
  methods: {
    addAddress() {
      this.close();
      localStorage.setItem('userDetail', JSON.stringify(this.userDetail));
      this.$router.push({ name: 'addAddress', query: {redirect_url: 'purchaseSelectPaymentAndShipping', bcNo: localStorage.getItem('nowBC')} });
    },
    isShow() {
      this.open = true;
    },
    changeAddress(deliveryId) {
      this.deliveryAddressId = deliveryId;
    },
    close() {
      this.$refs.modal__content.scrollTop = 0;
      scrollPosition.close();
      this.open = false;
    },
    send() {
      this.$refs.modal__content.scrollTop = 0;
      scrollPosition.close();
      let findItem = this.deliveryAddressList.findIndex((value) => value.deliveryAddressId == this.deliveryAddressId);
      this.$emit('deliveryAddressData', this.deliveryAddressList[findItem]);
      this.storeActionsDeliveryAddressData(this.deliveryAddressList[findItem]);
      this.open = false;
    },
    defaultDeliveryData(data) {
      for (var i = 0; i < data.length; i++) {
        if(data[i].selected) {
          this.deliveryAddressId = data[i].deliveryAddressId;
          this.$emit('deliveryAddressData', data[i]);
          this.storeActionsDeliveryAddressData(data[i]);
        }
      }
    },
    storeActionsDeliveryAddressData(data) {
      this.$store.dispatch(
        'commitUserDetailDeliveryAddressData', {
          recipientName: data.recipientName,
          deliveryAddressId: data.deliveryAddressId,
          zipCode: data.address.zipCode,
          prefectureName: data.address.prefecture.prefectureName,
          address: data.address.address,
          sameWithBc001: data.sameWithBc001,
        });
    },
    async apiGetdDeliveryAddress() {
      let bc = localStorage.getItem('nowBC');
      await DeliveryAddress.getDeliveryAddressList(bc).then((val) => {
        console.log(val);
        this.deliveryAddressList.push(...val.deliveryAddressList);
        let userDetail = JSON.parse(localStorage.getItem('userDetail'));
        if(userDetail) {
          console.log(userDetail);
          // APIで取得した一覧にストレージのaddressIdの値があるか検索
          let findItem = this.deliveryAddressList.findIndex((value) => value.deliveryAddressId == userDetail.deliveryAddressData.deliveryAddressId);
          if(findItem != -1) {
            // 一覧に一致するIDがあった場合
            this.deliveryAddressId = userDetail.deliveryAddressData.deliveryAddressId;
            this.$emit('deliveryAddressData', this.deliveryAddressList[findItem]);
            this.storeActionsDeliveryAddressData(this.deliveryAddressList[findItem]);
          } else {
            // 一覧に一致するIDがなかった場合
            this.defaultDeliveryData(val.deliveryAddressList);
          }
        } else {
          // ストレージにデータがなかった場合
          this.defaultDeliveryData(val.deliveryAddressList);
        }
      });
    },
  },
  computed: mapGetters(['userDetail']),
  created() {
    if(this.$route.query.status == 'addDeliveryAddress') {
      this.open = true;
    }
    this.apiGetdDeliveryAddress();
  }
}
</script>

<style lang="css" scoped>
.item_detail {
  bottom: 0;
  overflow-y: inherit;
  top: inherit;
}

/* .detail_wrap {
  height: 67%;
  overflow-y: inherit;
  overflow: hidden;
  padding-top: 64px;
} */
.content_title {
  letter-spacing: 3px;
  width: 103px;
}

.zip, .address {
  display: block;
  font-size: 14px;
}

.btn_yellow {
  margin-top: 8px;
}

/* 消したいけど消すとチェックされた時に青丸が出てこない */
.payment_contents {
  color: #c9c9c9;
  cursor: pointer;
  display: block;
  padding-left: 28px;
  position: relative;
  width: 100%;
}

.payment_contents::before,
.payment_contents::after {
  bottom: 0;
  border-radius: 100px;
  content: '';
  margin: auto;
  position: absolute;
  top: 0;
}
.payment_contents::before {
  background: #F5F5F5;
  border: 1px solid #AAAAAA;
  height: 20px;
  left: 0;
  width: 20px;
}

.payment_radio:checked + .payment_contents {
  color: #5a5a5a;
}

.payment_radio:checked + .payment_contents::after {
  background: #00C2FF;
  height: 12px;
  left: 5px;
  width: 12px;
}

.payment_radio {
  display: none;
}
.modal_item {
  /* overflow: scroll; */
  padding-bottom: 100px;
}

.modal_item .scroll {
  max-height: 200px;
  padding-bottom: 40px;
}
.btn_blue {
  margin-top: 15px;
}
.btn_wrap {
  padding-bottom: 40px;
}
</style>



// WEBPACK FOOTER //
// src/components/purchase/SelectAddress.vue